import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Pagination extends PureComponent {
  render() {
    const items = [];
    for (let i = 1; i < this.props.pages + 1; i++) {
      items.push(<li className={`${this.props.currentPage === i && 'active'}`}>
        <a href={`${this.props.url}/${i}${this.props.params || ''}`}>{i}</a>
      </li>);
    }
    return <ul className="pagination">{items}</ul>;
  }
}

Pagination.propTypes = {
  pages: PropTypes.number,
  currentPage: PropTypes.number,
  url: PropTypes.string.isRequired,
};

Pagination.defaultProps = {
  pages: 1,
  currentPage: 1,
};

export default Pagination;



// WEBPACK FOOTER //
// ./src/components/Pagination/index.js